import { openContactApp } from '@/utils/utils'

export const useContactApp = () => {
  const contactUs = () => {
    openContactApp()
  }

  return {
    contactUs,
    openContactApp
  }
}
